const selectEl = query => document.querySelector(query);
const selectElAll = query => document.querySelectorAll(query);
const headerTabs = selectElAll('.header__tab');
const referencesTables = selectElAll('.references-table');
const dropDown_type = selectElAll('#dropDown_type');

const clickHandler = index => {
  for (let i = 0; i < referencesTables.length; i++) {
    referencesTables[i].classList.toggle(
      'references-table--active',
      index === i
    );
    headerTabs[i].classList.toggle('header__tab--active', index === i);
  }

  dropDown_type[0].value = index;
};

//使用tab切換分類
for (let i = 0; i < headerTabs.length; i++) {
  headerTabs[i].addEventListener('click', e => clickHandler(i));
}

//使用dropdown切換分類
dropDown_type[0].addEventListener('change', e => clickHandler(parseInt(e.target.value)));

selectElAll('#references_nav_link')[0].classList.toggle('active', true)
selectElAll('#references_nav_link')[0].classList.toggle('font-weight-bold', true);